/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { BlockText as BlockTextRenderer } from "frontend/src/components/BlockText"
import { SectionGrid } from "frontend/src/components/Layout"

function BlockTextPlain({ content }) {
  return (
    <SectionGrid sx={{ marginTop: "50px" }}>
      <SectionGrid.narrow sx={{ mx: [5, 5, 0] }}>
        <BlockTextRenderer
          blocks={content}
          lang="de"
          style={{ hyphens: "auto", "-moz-hyphens": "auto" }}
        />
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { BlockTextPlain }
